// extracted by mini-css-extract-plugin
export default {"cartWarning":"cartWarning__1JDu8","warningIcon":"warningIcon__XKVMt","warningLink":"warningLink__5fHqY"};